import { Directive } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { BlobServiceClient } from '@azure/storage-blob';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[cvUpload]'
})
export class CVUploadDirective {
  constructor() { }

  async uploadFiles(files: File[]) {
    const uploadPromises = Array.from(files).map(file => this.uploadFile(file));
    const results = await Promise.all(uploadPromises);
    return results;
  }

  async uploadFile(file: File): Promise<string> {
    const newFileName = this.renameFile(file);
     var url = await this.uploadToAzure(file, newFileName);
    if (url) {
      return url;
    }
    return "";
  }

  renameFile(file: File): string {
    const fileName = file.name.split('.');
    const ext = fileName.pop();
    const baseName = fileName.join('.');
    return `${baseName}.${uuidv4()}.${ext}`;
  }

  async uploadToAzure(file: File, newFileName: string): Promise<string> {
    try {
      // Initialize BlobServiceClient
      const blobServiceClient = new BlobServiceClient(environment.azureStorageSasUrl);
      const containerClient = blobServiceClient.getContainerClient(environment.azureStorageContainerName);
      const blockBlobClient = containerClient.getBlockBlobClient(newFileName);
  
      // Convert file to ArrayBuffer for upload
      const fileArrayBuffer = await file.arrayBuffer();
  
      // Upload file
      const response = await blockBlobClient.uploadData(fileArrayBuffer, {
        blobHTTPHeaders: { blobContentType: file.type }
      });
      console.log("Upload successful:", blockBlobClient.url);
      return blockBlobClient.url;
    } catch (error) {
      console.error("Upload failed:", error);
      return "";
    }
  }
}
